import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule, MatButtonModule } from '@angular/material';

import { HeaderComponent } from '../header/header.component';

const imports = [
  MatToolbarModule,
  MatButtonModule,
  CommonModule,
];

const exps = [
  HeaderComponent,
];

const declarations = [
  HeaderComponent,
];

@NgModule({
  imports: [...imports],
  exports: [...exps],
  declarations: [...declarations]
})
export class HeaderModule { }
